export const PermissionList ={
    Access_To_Pilot_Station: "Access_To_Pilot_Station",
    Display_Real_Aircraft: "Display_Real_Aircraft",
    Control_Real_Aircraft: "Control_Real_Aircraft",
    Control_Simulator_Aircraft: "Control_Simulator_Aircraft",
    Use_Test_Layout: "Use_Test_Layout",
}
